import { HotelAccessCodesList } from '@/components/hotel-access-codes/HotelAccessCodesList';
import {
  hotelAccessCodeCrudConfig,
  type HotelAccessCode,
} from '@/config/objects/hotel-access-codes';
import { useApiClient, type CrudConfig } from '@startupquickstart/frontend';
import { useCallback, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from '@startupquickstart/frontend';

export function HotelAccessCodesTab() {
  const { id } = useParams<{ id: string }>();
  const apiClient = useApiClient();
  const navigate = useNavigate();

  const hotelAccessCodesConfig: CrudConfig<HotelAccessCode> = useMemo(
    () => ({
      ...hotelAccessCodeCrudConfig,
      entityName: 'Access Code',
      entityNamePlural: 'Access Codes',
      endpoints: {
        ...hotelAccessCodeCrudConfig.endpoints,
        list: `/hotels/${id}/access-codes`,
        delete: (accessCodeId: string) => `/hotels/${id}/access-codes/${accessCodeId}`,
      },
      listView: {
        ...hotelAccessCodeCrudConfig.listView,
        actions: {
          create: {
            enabled: true,
            // Hotel-scoped full-page create form (sibling route).
            url: `/hotels/${id}/access-codes/new`,
          },
          view: {
            enabled: true,
          },
          remove: {
            enabled: true,
            onRemove: async (accessCode: HotelAccessCode) => {
              await apiClient.delete(`/hotels/${id}/access-codes/${accessCode.id}`);
              toast.success('Access code removed from hotel');
            },
          },
        },
      },
    }),
    [id, apiClient],
  );

  // Open the detail page nested under the hotel.
  const handleItemClick = useCallback(
    (accessCode: HotelAccessCode) => {
      navigate(`/hotels/${id}/access-codes/${accessCode.id}`);
    },
    [navigate, id],
  );

  if (!id) return null;

  return (
    <HotelAccessCodesList
      config={hotelAccessCodesConfig}
      className="p-0"
      baseUrl="/hotel-access-codes"
      onItemClick={handleItemClick}
    />
  );
}
